var _path, _path2, _path3, _path4;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPhoneSearch = function SvgPhoneSearch(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.375 19.125V30.777C21.375 31.3153 21.269 31.8483 21.0629 32.3456C20.8569 32.8429 20.5549 33.2947 20.1742 33.6753C19.7935 34.0558 19.3416 34.3576 18.8442 34.5635C18.3468 34.7693 17.8138 34.8752 17.2755 34.875H7.4745C6.93622 34.8752 6.40317 34.7693 5.9058 34.5635C5.40844 34.3576 4.9565 34.0558 4.57581 33.6753C4.19511 33.2947 3.89312 32.8429 3.68709 32.3456C3.48105 31.8483 3.375 31.3153 3.375 30.777V7.4745C3.375 6.38724 3.80691 5.34452 4.57572 4.57572C5.34452 3.80691 6.38724 3.375 7.4745 3.375H12.375",
    stroke: "#80ABFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.375 28.125H21.375",
    stroke: "#80ABFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 14.625C26.2279 14.625 29.25 11.6029 29.25 7.875C29.25 4.14708 26.2279 1.125 22.5 1.125C18.7721 1.125 15.75 4.14708 15.75 7.875C15.75 11.6029 18.7721 14.625 22.5 14.625Z",
    stroke: "#0258FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.27 12.645L32.625 18",
    stroke: "#0258FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPhoneSearch, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/phone-search.17e445e0.svg";
export { ForwardRef as ReactComponent };